import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function userReducer(state = initialState.user, action) {
	switch (action.type) {
		case types.LOGIN:
			return { ...action.data };
		case types.LOGOUT:
			return {
				...initialState.user,
			};
		default:
			return state;
	}
}
